import React, { useEffect, useState } from 'react'
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import CommonFormHeading from '../../CommonUtils/CommonFormHeading';
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';
import * as bie from "react-bootstrap";
import { viewImage } from '../../CommonUtils/viewImage';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import Swal from 'sweetalert2';
import { CiWarning } from "react-icons/ci";
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
import { FaEye } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { GetCollegeType } from '../../Reducers/AffiliationCommonservice';

export default function AffiliationQuestionsSection5() {
    const Collegetype = useSelector((state) => state?.commonMastersReducer?.CollegeType);
    const [performance, setperformance] = useState([]);
    const AfflAuestion5validation = Yup.object().shape({
        uploadFfca: Yup.string().required(ERROR_MSG).nullable(),
        aisheFfca: Yup.string().required(ERROR_MSG).nullable(),
        apscheFfca: Yup.string().required(ERROR_MSG).nullable(),
        ...performance?.reduce((acc, empdata) => {
            const fieldName = `col${empdata?.parameter_id}`;
            acc[fieldName] = Yup.string().oneOf(['1', '2'], `Invalid selection for ${empdata?.parameter_name}`).required(ERROR_MSG);
            return acc;
        }, {}),
    });
    const Afflquestion5formik = useFormik({
        initialValues: {
            uploadFfca: "",
            aisheFfca: "",
            apscheFfca: "",
            ...(performance?.reduce((acc, empdata) => {
                acc[`col${empdata?.parameter_id}`] = '';
                return acc;
            }, {})),

        },
        validationSchema: AfflAuestion5validation,
        onSubmit: (values) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveAffiliationQuestions5details`;
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetQuestion5Data();
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });

        },
    })


    function GetperformanceData() {
        let url = config.url.API_URL + "getperformanceData";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setperformance(res?.data?.Performances);
                res?.data?.Performances?.forEach((empdata) => {
                    const fieldName = `col${empdata?.parameter_id}`;
                    const fieldValue = '';
                    Afflquestion5formik?.setFieldValue(fieldName, fieldValue);
                });


            } else {
                setperformance([])

            }
        })
    }
    function GetQuestion5Data() {
        let url = config.url.API_URL + "getAffiliationQuestions5Details";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                const question5Details = res?.data?.getAffiliationQuestions5Details[0];
                Afflquestion5formik?.setFieldValue("uploadFfca", question5Details?.upload_ffca);
                Afflquestion5formik?.setFieldValue("aisheFfca", question5Details?.aishe_ffca);
                Afflquestion5formik?.setFieldValue("apscheFfca", question5Details?.apsche_ffca);
                if (question5Details) {
                    for (let field in question5Details) {
                        if (question5Details?.hasOwnProperty(field)) {
                            const fieldName = `col${field?.replace('col_', '')}`;
                            Afflquestion5formik?.setFieldValue(fieldName, question5Details[field]?.toString());
                        }
                    }
                } else {
                    console.log("No details found ");
                }
            } else {
                console.log("No details found ");
            }
        })
    }
    useEffect(() => {

        GetperformanceData();
        GetQuestion5Data();
        GetCollegeType();

    }, [])

    return (
        <>
            {Collegetype && Collegetype === "SqFt" ? (<div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    padding: '20px',
                    textAlign: 'center',
                }}
            >
                <h2
                    style={{
                        fontSize: '24px',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        letterSpacing: '2px',
                        animation: 'fadeIn 1.5s ease-in-out',
                        color: "red"
                    }}
                >
                    This section is for Engineering colleges only
                </h2>
            </div>) : (<>

                <CommonFormHeading heading="Institute response to Parameters for Grant of Affiliation" />

                <bie.Container fluid className="px-1" >
                    <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                        <FormikProvider value={Afflquestion5formik}>

                            <Form onChange={Afflquestion5formik.handleChange} onSubmit={Afflquestion5formik.handleSubmit} className='affl-form'>

                                <bie.Row className="px-2 pt-3 mb-3">
                                    <bie.Row>
                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                            <label className='mb-1 field-mandatory' >Is information Uploaded in AISHE Portal :</label>
                                            <Field as='select' name="aisheFfca" className='form-control mb-2'>
                                                <option value=''>---select---</option><option value='1'>Yes</option><option value='2'> No</option></Field>
                                            <ErrorMessage name="aisheFfca" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                            <label className='mb-1 field-mandatory'>Is information Uploaded in APSCHE PORTAL :</label>
                                            <Field as='select' name="apscheFfca" className='form-control'>
                                                <option value=''>---select---</option>
                                                <option value='1'>Yes</option>
                                                <option value='2'> No</option>

                                            </Field>
                                            <ErrorMessage name="apscheFfca" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                            <label className='mb-1 field-mandatory' >Supporting Documents :</label>
                                            <div className='d-flex align-items-center'>
                                                <input type="file" className="form-control mt-xl-3 mt-xxl-0 mt-lg-3" name="uploadFfca" accept="application/pdf"
                                                    onChange={(e) => {
                                                        let filename = `uploadFfca`
                                                        let path = "/Uploads/ffca_questionnaire5/2023/"
                                                        ImagePdfBucket(e, Afflquestion5formik, path, "uploadFfca", filename, "pdf")
                                                    }}
                                                />
                                                {Afflquestion5formik?.values?.uploadFfca && <button type='button' className='btn btn-primary' onClick={() => { viewImage(Afflquestion5formik?.values?.uploadFfca) }}><FaEye size={20} className='ms-2' /></button>}
                                                <ErrorMessage name="uploadFfca" component="div" className="text-error" />
                                            </div>
                                        </bie.Col>
                                    </bie.Row>

                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">

                                            <tbody>
                                                {performance?.map((empdata, index) => (
                                                    <tr key={index}>
                                                        <td style={{ width: "3%" }} className='cen'>{index + 1}</td>
                                                        <td className='text-left'>{empdata?.parameter_name}</td>
                                                        <td style={{ width: "10%" }}>
                                                            <div style={{ position: 'relative' }}>
                                                                <Field as='select' name={`col${empdata?.parameter_id}`} className='form-control'>
                                                                    <option value=''>--select--</option><option value='1'> Yes</option><option value='2'> No</option>
                                                                </Field>

                                                                {Afflquestion5formik.errors[`col${empdata?.parameter_id}`] && Afflquestion5formik.touched[`col${empdata?.parameter_id}`] && (
                                                                    <div style={{ color: "#c9463c" }}>
                                                                        <CiWarning size={"15px"} />
                                                                        {Afflquestion5formik.errors[`col${empdata?.parameter_id}`]}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table >
                                    </div >

                                    <div className="pt-1 mb-2">
                                        <button type='submit' className='btn btn-success  float-end  mb-2  '>Submit</button>
                                    </div>
                                </bie.Row>
                            </Form>
                        </FormikProvider>
                    </bie.Container>
                </bie.Container>


            </>)}



        </>
    )
}
